$(document).on('hide.bs.modal', '#modal', function () {
    $('.tox-tinymce-aux').remove();
});
